<div class="table-wrapper flex flex-col">
	<ui-section title="Accounting Details" class="w-full max-w-[1200px] mt-2">
		<div section-content>
			<div class="flex justify-between my-2 items-center">
				<label>Accounting platform</label>
				<div class="flex justify-between my-2 items-right">
					<app-dropdown
						intercomAttr="intercom-accounting-platform-dropdown"
						class="w-fit"
						[ngModel]="accountingExportOptionLabel"
						[itemGroups]="[{ items: accountingExportOptions }]"
						(onSelect)="onSelectAccountingExporting($event)"
						[disabled]="isLeapEnabled"
					></app-dropdown>
					<app-icon
						[icon]="ICON.INFO"
						class="ml-2 mt-2"
						matTooltip="The accounting platform selected will set the nature of the Statement of Account's HST rounding"
					></app-icon>
				</div>
			</div>

			<div *ngIf="isLeapEnabled" class="justify-between my-2 items-center">
				<label>Import accounting codes from LEAP</label>
				<app-icon
					[icon]="ICON.INFO"
					class="ml-2"
					matTooltip='Click "Import" to import/refresh activity & recovery codes from LEAP into Closer.'
				></app-icon>
			</div>

			<div *ngIf="isLeapEnabled">
				<app-button
					[loading]="importing"
					[disabled]="importing"
					(click)="importLeap()"
					size="small"
					class="ml-0"
					[intercomAttr]="'soc-leap-import-accounting-codes'"
					[icon]="ICON.FILE_IMPORT"
					>Import</app-button
				>
			</div>

			<div
				class="flex flex-col my-2"
				*ngIf="
					accountingExportSettings.accountingPlatform &&
					accountingExportSettings.accountingPlatform !== 'quickbooks' &&
					!isLeapEnabled
				"
			>
				<div class="flex justify-between items-center">
					<label>Accounting export file identifier</label>
					<div>
						<app-radio-group
							class="w-96"
							intercomAttr="intercom-accounting-identifier-radio-group"
							type="compact"
							[items]="accountingIdentifierOptions"
							[ngModel]="accountingExportSettings.accountingIdentifier"
							(ngModelChange)="onSelectAccountingIdentifier($event)"
						></app-radio-group>
					</div>
				</div>

				<div class="flex justify-end mt-4" *ngIf="isSolunoEnabled">
					<app-anchor
						intercomAttr="intercom-accounting-manage-codes-anchor"
						[icon]="ICON.EDIT"
						type="static"
						(click)="openSolunoImportModal()"
						>Manage Accounting Codes</app-anchor
					>
				</div>
			</div>
			<div class="flex flex-col my-2" *ngIf="isGhostPracticeEnabled">
				<div class="flex justify-end mt-4">
					<app-anchor
						intercomAttr="intercom-accounting-manage-codes-anchor"
						[icon]="ICON.EDIT"
						type="static"
						(click)="openGhostPracticeImportModal()"
						>{{ ghostPracticeAnchorText() }}</app-anchor
					>
				</div>
			</div>
			<div class="flex flex-col my-2" *ngIf="isLeapEnabled">
				<div class="flex justify-end mt-4">
					<app-anchor
						intercomAttr="intercom-accounting-manage-codes-anchor"
						[icon]="ICON.EDIT"
						type="static"
						(click)="openLeapManageModal()"
						>How to Manage Accounting Codes</app-anchor
					>
				</div>
			</div>
		</div>
	</ui-section>

	<ui-section title="Statement of Account Details" class="max-w-[1200px] mt-8">
		<div section-content class="my-2">
			<div class="flex justify-between items-center">
				<label> File type </label>
				<div>
					<app-radio-group
						[items]="fileTypesOptions"
						[(ngModel)]="selectedFileType"
					></app-radio-group>
				</div>
			</div>

			<div class="flex justify-between mt-2">
				<app-set-fee class="w-full" [fileType]="selectedFileType"></app-set-fee>
			</div>
		</div>
	</ui-section>

	<app-statement-of-account-defaults-list
		[title]="soaDefaultsTitles.conveyancingFees"
		[statements]="statements()"
		[solunoActivityCodes]="solunoActivityCodes"
		[ghostPracticeCodes]="ghostPracticeHSTDisbursementCodes"
		[fileType]="selectedFileType"
		[showSolunoActivityCodeDropdown]="isSolunoEnabled"
		[showGhostPracticeCodeDropdown]="isGhostPracticeEnabled"
		[showLeapFeeTaskCodesDropdown]="isLeapEnabled"
		[statementType]="statementTypes.FEE"
	>
	</app-statement-of-account-defaults-list>

	<app-statement-of-account-defaults-list
		[title]="soaDefaultsTitles.hstDisbursements"
		[statements]="statements()"
		[solunoActivityCodes]="solunoActivityCodes"
		[ghostPracticeCodes]="ghostPracticeHSTDisbursementCodes"
		[showSolunoActivityCodeDropdown]="isSolunoEnabled"
		[showGhostPracticeCodeDropdown]="isGhostPracticeEnabled"
		[showLeapFeeTaskCodesDropdown]="isLeapEnabled"
		[fileType]="selectedFileType"
		[statementType]="statementTypes.HST"
	>
	</app-statement-of-account-defaults-list>

	<app-statement-of-account-defaults-list
		[title]="soaDefaultsTitles.nonHstDisbursements"
		[statements]="statements()"
		[solunoActivityCodes]="solunoActivityCodes"
		[ghostPracticeCodes]="ghostPracticeNonHSTDisbursementCodes"
		[fileType]="selectedFileType"
		[showSolunoActivityCodeDropdown]="isSolunoEnabled"
		[showGhostPracticeCodeDropdown]="isGhostPracticeEnabled"
		[showLeapFeeTaskCodesDropdown]="isLeapEnabled"
		[statementType]="statementTypes.NON_HST"
	>
	</app-statement-of-account-defaults-list>
</div>

<ng-template #titleTemplate>
	<div class="w-full flex px-5 py-4 justify-between">
		<h4>Accounting Details</h4>
		<img
			*ngIf="isCosmolexEnabled"
			class="w-[120px] h-[20px]"
			src="/assets/images/integrations/cosmolex-logo.png "
		/>
		<img
			*ngIf="isSolunoEnabled"
			class="w-[135px] h-[30px]"
			src="/assets/images/integrations/soluno-logo.png "
		/>
		<div
			*ngIf="isGhostPracticeEnabled"
			class="text-lg font-semibold text-gray-700"
		>
			GhostPractice
		</div>
		<img
			*ngIf="isLeapEnabled"
			class="w-[135px] h-[29px]"
			src="assets/images/leap/leap-logo-primary-soa.png"
		/>
	</div>
</ng-template>
